/**
 * Support chat kill-switch for client_dashboard.
 * Set to false and restore timezone checks below if chat should return.
 */
const CHAT_COMPLETELY_DISABLED = true

const CHAT_DISABLED_TIMEZONES = ['Asia/Tehran', 'Asia/Kabul']

export function getBrowserTimezone() {
  try {
    return Intl.DateTimeFormat(undefined, { timeZoneName: 'long' }).resolvedOptions().timeZone
  } catch (e) {
    return null
  }
}

/** Chat is disabled for all users while CHAT_COMPLETELY_DISABLED is true. */
export function isChatDisabledTimezone(timezone = getBrowserTimezone()) {
  if (CHAT_COMPLETELY_DISABLED) {
    return true
  }
  return CHAT_DISABLED_TIMEZONES.includes(timezone)
}
